import * as defaultImport from "@splunk/react-icons/Markdown";
export * from "@splunk/react-icons/Markdown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
